// extracted by mini-css-extract-plugin
module.exports = {"btn":"back-to-top-component_btn__20D2z"};